'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _Switch = _interopRequireDefault(require("Components/Forms/Elements/Switch"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _CompanyAccountStatusModal = _interopRequireDefault(require("Modals/CompanyAccountStatusModal"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _options = require("Shared/options");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const {
  app
} = window;
class CompanyForm extends _react.Component {
  state = {
    status_messages: {},
    current_tab: 0,
    'company[monitoring]': [],
    'company[account_status]': [],
    openAccountStatusModal: false,
    monitoring_modal_trigger: undefined,
    'company[cgu_accepted]': true
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchCompany();
    }
    component.fetchUser();
    component.fetchCompanyActivity();
  }
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-all', {
      id: props.id || document.location.pathname.split('/liste-des-entreprises/')[1],
      with_count: false
    }).then(function (xhr, response) {
      let company_monitoring = (response.companies[0]?.monitoring || []).map(function (data, i) {
        let file_parsed = (data.file || []).map(function (file) {
          let descriptor = {
            ...file,
            status: 'uploaded',
            filename: file.url.slice(file.url.lastIndexOf('/') + 1),
            pdf: true
          };
          return descriptor;
        });
        let monitoring = {
          ...data,
          file: file_parsed
        };
        component.setState({
          ['__files-company[monitoring][' + monitoring.id + '][file]']: file_parsed
        });
        return monitoring;
      });
      delete response.companies[0]?.monitoring;
      const logo = (response.companies[0]?.logo || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1)
        };
        return descriptor;
      });
      delete response.companies[0].logo;
      const customer_proposal_pdf = (response.companies[0]?.integration_collaborator?.customer_proposal_pdf || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.companies[0]?.integration_collaborator?.customer_proposal_pdf;
      const customer_proposal_accepted_pdf = (response.companies[0]?.integration_collaborator?.customer_proposal_accepted_pdf || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.companies[0]?.integration_collaborator?.customer_proposal_accepted_pdf;
      const account_status = response.companies[0]?.account_status;
      delete response.companies[0].account_status;
      const update = (0, _getStateFromObject.default)({
        data: response.companies[0],
        model: 'company'
      });
      component.setState({
        ...update,
        'company[monitoring]': company_monitoring,
        'company[account_status]': account_status,
        'company[logo]': logo,
        ['__files-company[logo]']: logo,
        'company[integration_collaborator][customer_proposal_pdf]': customer_proposal_pdf,
        ['__files-company[integration_collaborator][customer_proposal_pdf]']: customer_proposal_pdf,
        'company[integration_collaborator][customer_proposal_accepted_pdf]': customer_proposal_accepted_pdf,
        ['__files-company[integration_collaborator][customer_proposal_accepted_pdf]']: customer_proposal_accepted_pdf,
        fetch_id: (0, _uniqid.default)(),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    component.setState({});
  };
  fetchCompanyActivity = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        company_activities: response.company_activities
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/user/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        users: response.users
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const company = (0, _getFormData.default)({
      state: state,
      pattern: 'company['
    });
    const url = props.type === 'update' ? '/company/update' : '/company/create';
    qwest.post(url, company).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchCompany();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/liste-des-entreprises');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleCheckboxChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  addMonitoring = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let monitoring = state['company[monitoring]'];
    monitoring.push({
      date: (0, _moment.default)().format('YYYY-MM-DD'),
      comment: '',
      goals: '',
      file: [],
      id: id
    });
    component.setState({
      'company[monitoring]': monitoring
    });
  };
  deleteMonitoring = monitoring_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const monitoring_filtered = state['company[monitoring]'].filter(function (monitoring) {
      return monitoring['id'] !== monitoring_id;
    });
    let binary_file = '__files-company[monitoring][' + monitoring_id + '][file]';
    component.setState({
      'company[monitoring]': monitoring_filtered,
      [binary_file]: undefined
    });
  };
  handleMonitoringChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let monitoring = (state['company[monitoring]'] || []).find(monitoring => monitoring.id === id);
    monitoring[field_name] = value;
    component.setState({
      monitoring: state.monitoring
    });
  };
  handleMonitoringFileChange = ({
    e,
    previews,
    name,
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const files_descriptor = previews.map(function (preview) {
      let data = {
        status: preview.file instanceof File ? 'new' : 'uploaded'
      };
      if (data.status === 'uploaded') {
        if (preview.url) data.url = preview.url;
        if (preview.pdf) data.pdf = preview.pdf;
      } else {
        data.filename = preview.filename;
      }
      return data;
    });
    delete state.status_messages[name];
    let monitoring = (state['company[monitoring]'] || []).find(monitoring => monitoring.id === id);
    monitoring.file = files_descriptor;
    component.setState({
      ['__files-' + name]: previews,
      monitoring: state.monitoring,
      status_messages: state.status_messages,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('company[')).reduce(function (update, key) {
      console.log(state[key], _is_js.default.string(state[key]));
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  toggle = (e, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.open === id) {
      component.setState({
        open: undefined
      });
    } else {
      component.setState({
        open: id
      });
    }
  };
  handleAccountStatusChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      ['company[account_status]']: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  getStatusLabel = status => {
    const component = this,
      props = this.props,
      state = this.state;
    return _options.account_status_options.find(opt => opt.value === status)?.label || '';
  };
  openAccountStatusModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openAccountStatusModal: true,
      monitoring_modal_trigger: e.target
    });
  };
  closeAccountStatusModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openAccountStatusModal: false,
      monitoring_modal_trigger: undefined
    });
  };
  handleMonitoringDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = name.split('company[monitoring][')[1];
    id = id.slice(0, id.indexOf(']'));
    let monitoring = (state['company[monitoring]'] || []).find(monitoring => monitoring.id === id);
    if (monitoring) {
      console.log('monitoring.date', monitoring.date);
      monitoring.date = value;
      component.setState({
        'company[monitoring]': state['company[monitoring]']
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const accompanist_options = (state.users || []).filter(user => user.roles.includes('super_admin') === false).map(function (user) {
      let option = {
        label: user.firstname + ' ' + user.lastname,
        value: user.id
      };
      return option;
    });
    let monitoring_list = (state['company[monitoring]'] || []).sort((a, b) => (0, _moment.default)(b.date).diff((0, _moment.default)(a.date))).map(function (monitoring, i) {
      let modifiers = ['monitoring'];
      if (monitoring.id === state.open) modifiers.push('open');
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _bemit.default)('c-collapse', modifiers),
        key: monitoring.id
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: (0, _bemit.default)('c-collapse-toggle', modifiers),
        onClick: e => component.toggle(e, monitoring.id)
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "c-collapse-toggle__txt"
      }, "Suivi - ", i + 1)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        in: state.open === monitoring.id,
        timeout: "auto",
        className: "c-collapse__collapsed"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        classes: props.classes,
        className: "u-padding-10"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        name: 'company[monitoring][' + monitoring.id + '][date]',
        label: "Date du RDV",
        onChange: component.handleMonitoringDateChange,
        value: monitoring.date,
        error: state.status_messages?.['company[monitoring][' + monitoring.id + '][date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
        accept: ".pdf",
        onChange: ({
          e,
          previews,
          name
        }) => {
          component.handleMonitoringFileChange({
            e,
            previews,
            name,
            id: monitoring.id
          });
          component.handleFileChange;
        },
        name: 'company[monitoring][' + monitoring.id + '][file]',
        data: state,
        multiple: true,
        status: state.status_messages,
        label: "Fichier"
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'comment'
        }),
        value: monitoring.comment || '',
        name: 'company[monitoring][' + monitoring.id + '][comment]',
        label: "Notes",
        multiline: true,
        rows: "5",
        "without-headings": true,
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'goals'
        }),
        value: monitoring.goals || '',
        name: 'company[monitoring][' + monitoring.id + '][goals]',
        label: "Objectifs pour le prochain RDV",
        multiline: true,
        rows: "5",
        "without-headings": true,
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteMonitoring(monitoring.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))))));
      return output;
    });
    let company_activities_options = (state.company_activities || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (company_activity) {
      let option = {
        label: company_activity.label,
        value: company_activity.id
      };
      return option;
    });
    let account_status_list = (state['company[account_status]'] || []).map(function (account_status, i) {
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: i
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getStatusLabel(account_status.status)));
      return output;
    });
    const columns = [{
      id: 'status',
      sortable: false,
      numeric: false,
      label: 'Statut',
      center: true
    }];
    const user_roles = app.state.session?.user?.roles;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/company/create"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "candidate-title-back"
    }, state['company[company_name]']), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "tabs-paper",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Coordonn\xE9es & Compte",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Informations sur l'entreprise",
      value: 1
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Demandes",
      value: 2
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Suivi",
      value: 3
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Bilan",
      value: 4
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Statut du compte",
      value: 5
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Droits",
      value: 6
    }))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 0,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations de connexion"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[login]'],
      name: "company[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[password]'],
      name: "company[password]",
      type: "password",
      label: "Mot de passe",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Coordonn\xE9es de la personne en charge du recrutement"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[lastname]'],
      name: "company[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[firstname]'],
      name: "company[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[profession]'],
      name: "company[profession]",
      type: "text",
      label: "Fonction dans l'entreprise",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[home_phone_number]'],
      name: "company[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[phone_number]'],
      name: "company[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 1,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Raison sociale",
      onChange: component.handleChange,
      value: state['company[company_name]'],
      name: "company[company_name]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Site web",
      onChange: component.handleChange,
      value: state['company[website_url]'],
      name: "company[website_url]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['company[company_activity]'],
      name: "company[company_activity]",
      label: "Secteur d\u2019activit\xE9",
      status: state.status_messages,
      options: company_activities_options,
      defaultValue: company_activities_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Adresse",
      onChange: component.handleChange,
      value: state['company[company_address][line_1]'],
      name: "company[company_address][line_1]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Compl\xE9ment d'adresse",
      onChange: component.handleChange,
      value: state['company[company_address][line_2]'],
      name: "company[company_address][line_2]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['company[company_address][postal_code]'],
      name: "company[company_address][postal_code]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Ville",
      onChange: component.handleChange,
      value: state['company[company_address][city]'],
      name: "company[company_address][city]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "company[logo]",
      data: state,
      status: state.status_messages,
      label: "Logo de l'entreprise"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[description]"] || '',
      name: "company[description]",
      label: "Description",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 2,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, !user_roles.includes('accompanist') ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Nom Accompagnateur AEAA"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['company[accompanist_id]'],
      name: "company[accompanist_id]",
      label: "",
      status: state.status_messages,
      options: accompanist_options,
      "default-value": accompanist_options[0]?.value
    }))) : undefined, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Nom Accompagnateur ASPIEJOB CONSEIL"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "",
      onChange: component.handleChange,
      value: state['company[aspie_accompanist]'],
      name: "company[aspie_accompanist]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Demandes"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Publication d'une annonce",
      name: "company[demand][create_ad]",
      value: state['company[demand][create_ad]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Int\xE9gration de collaborateurs Asperger (TSA)",
      name: "company[demand][integration_help]",
      value: state['company[demand][integration_help]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Maintien dans l'emploi de collaborateurs Asperger (TSA)",
      name: "company[demand][need_intervention_to_collaborator]",
      value: state['company[demand][need_intervention_to_collaborator]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Mise en place d\u2019une Pr\xE9paration Op\xE9rationnelle \xE0 l'Emploi (POE et POEI) pour former et recruter des collaborateurs Asperger (TSA)",
      name: "company[demand][poe_poei]",
      value: state['company[demand][poe_poei]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Formation du R\xE9f\xE9rent handicap aux sp\xE9cificit\xE9s des collaborateurs Asperger (TSA)",
      name: "company[demand][help_tutor]",
      value: state['company[demand][help_tutor]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Formations",
      name: "company[demand][formations]",
      value: state['company[demand][formations]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sensibilisation",
      name: "company[demand][sensibilisation]",
      value: state['company[demand][sensibilisation]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre (d\xE9crire la demande)",
      name: "company[demand][other]",
      value: state['company[demand][other]'] === true,
      status: state.status_messages
    })), state['company[demand][other]'] === true ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Demande",
      onChange: component.handleChange,
      value: state['company[other_demand]'],
      name: "company[other_demand]",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Commentaire"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[situation_comment]"] || '',
      name: "company[situation_comment]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Les collaborateurs sont d\xE9j\xE0 pr\xE9sents dans l'entreprise"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['company[integration_collaborator][in_company]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "company[integration_collaborator][in_company]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['company[integration_collaborator][in_company]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "company[integration_collaborator][in_company]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Situation et besoin(s)"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[integration_collaborator][description_needs]"] || '',
      name: "company[integration_collaborator][description_needs]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Mission(s) et action(s) \xE0 proposer"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[integration_collaborator][mission_description]"] || '',
      name: "company[integration_collaborator][mission_description]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Proposition adress\xE9e au client"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[integration_collaborator][customer_proposal]"] || '',
      name: "company[integration_collaborator][customer_proposal]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      name: "company[integration_collaborator][customer_proposal_pdf]",
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Documents"
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Proposition accept\xE9e par le client"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[integration_collaborator][customer_proposal_accepted]"] || '',
      name: "company[integration_collaborator][customer_proposal_accepted]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      name: "company[integration_collaborator][customer_proposal_accepted_pdf]",
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Documents"
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Personne en charge de la mission"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "",
      onChange: component.handleChange,
      value: state['company[integration_collaborator][mission_to_complete]'],
      name: "company[integration_collaborator][mission_to_complete]",
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 3,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addMonitoring
    }, "Ajouter un suivi")), monitoring_list)), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 4,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Bilan"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[bilan]"] || '',
      name: "company[bilan]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Am\xE9liorations"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["company[improvement]"] || '',
      name: "company[improvement]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 5,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-full-width u-margin-bottom-10"
    }, "Statut en cours : " + component.getStatusLabel(state['company[current_account_status]'])), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Suivi de statut",
      className: "u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      columns: columns,
      order: "undefined",
      order_by: "undefined",
      row_count: account_status_list.length
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, account_status_list)), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.openAccountStatusModal
    }, "Changer de statut", loader))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 6,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['company[get_cv]'] === true,
      name: "company[get_cv]",
      "top-label": "Acc\xE8s \xE0 la CVth\xE8que",
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['company[create_jobad]'] === true,
      name: "company[create_jobad]",
      "top-label": "D\xE9poser une offre",
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages
    })))), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cette entreprise')), loader, /*#__PURE__*/_react.default.createElement(_CompanyAccountStatusModal.default, {
      company_id: state['company[id]'],
      onAccountChange: component.handleAccountStatusChange,
      onChange: component.handleChange,
      current_status: state['company[current_account_status]'],
      monitoring_account_status: state['company[account_status]'],
      open: state.openAccountStatusModal,
      onClose: component.closeAccountStatusModal,
      add_modal_trigger: state.monitoring_modal_trigger
    }));
    return output;
  }
}
exports.default = CompanyForm;
